import _ from 'lodash';
import QuestionSummaryViewModel from './QuestionSummaryViewModel';

class TextAreaViewModel extends QuestionSummaryViewModel {
}

export default TextAreaViewModel;
